module.exports = __webpack_public_path__ + "static/media/maintenance.de8ca10a.png";